import { render, staticRenderFns } from "./modaPolicyExchange.vue?vue&type=template&id=4150484b&scoped=true"
import script from "./modaPolicyExchange.vue?vue&type=script&lang=js"
export * from "./modaPolicyExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4150484b",
  null
  
)

export default component.exports